import { useEffect, useState } from "react";
import LoadingStuck from "../../../reuse/LoadingStuck";
import Api, { BaseUrl } from "../../../../api/Api";
import Select from "react-select";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import JsonProcessorV2 from "./JsonProcessor_v2";

const TestCard = ({data}) => {
    return(
        <>
        <Card className="m-1 text_font" onClick={()=>{window.location.href=`/admin_page_settings/tests/${data.id}`}}>
            <Card.Header>id: {data.id}</Card.Header>
            <Card.Body>
                <div>Версия: {data.name}</div>
                <div>Дата создания: {new Date(data.created_at).toLocaleString()}</div>
                <div>Описание: {data.description}</div>
            </Card.Body>
        </Card>
        </>
    )
}

const ModalCreateTest=()=>{
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return(
        <>
        <Button className="m-1" onClick={handleShow}>Создать</Button>
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title className="text_font">Загрузка версии теста в формате JSON файла</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <JsonProcessorV2/>
            </Modal.Body>
        </Modal>
        </>
    )
}

const AdminTestInterface = ({data}) => {
    const [data_tests,setDataTests]=useState(data);
    const filters_tests_options=data.map((test)=>{return {value:test.id, label:test.name}})
    const [filterValue,setFilterValue]=useState("");

    const handleChange = (selected) => {
        setFilterValue(selected);
        if(selected==null){
            setDataTests(data)
        }else{
            const new_data=data.filter(item => item.id === selected.value);
            setDataTests(new_data);
        }
    }

    return(
        <>
        <div className="search_filters_admin_block">
            <ModalCreateTest/>
            <Select 
            className="m-1 search_filter_field" 
            options={filters_tests_options}
            value={filterValue}
            onChange={handleChange}
            placeholder="поиск по тестам..." 
            isClearable/>
        </div>
        <div>
            {/* {JSON.stringify(data)} */}
            {data_tests.length==0 ? 
            <p>Нет тестов</p> : <>
            <Row className="mt-1">
                {data_tests.map((item)=> (
                    <Col key={item.id} md={4} className="mb-1">
                        <TestCard data={item}/>
                    </Col>
                ))}
            </Row>
            </> }
        </div>
        </>
    )
}

const AdminTestFetch = () =>{
    const [loading, setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [block, setBlock]=useState(false);
    const [errorInfo, setErrorInfo]=useState("");
    const [data, setData]=useState(null);

    const getTestData = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/tests/`,
                headers:{} 
            })
            setBlock(true);
            setData(response.data)
        } catch (error) {
            setErrorInfo(`Ошибка при подгрухке данных о тестах. ${error}`);
            setError(true);
        }
    }

    useEffect(()=>{
        const setup =async()=>{
            setLoading(true)
            await getTestData()
            setLoading(false)
        }
        setup();
    },[])

    if(loading){return(<LoadingStuck/>)};
    if(error){return(<><p className="warning_text sepatate_text">{errorInfo}</p></>)};
    if(block){return(<AdminTestInterface data={data}/>)};

}

const AdminTestBlock = () => {
    return(<AdminTestFetch/>)
}
export default AdminTestBlock;